<template>
<div class="fff">
<div class="page_title">Take the device that you want to monitor and follow the on-screen instructions</div>
<div class="Take">
        Ensure that the target device is unlocked, charged, and is connected to the Internet via Wi-Fi or Cellular Data Connection.
    </div>
<div class="twoButton">
<div class="BackButton">Back</div>
<div class="loginButton">Continue</div>
</div>
</div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff{width:100%;position:absolute;height:100%;background:#fff;overflow:hidden}
.Take{font-size:14px;color:grey;line-height:20px;margin-left:5%;width:85%;max-width:800px}

</style>



// WEBPACK FOOTER //
// src/components/Take.vue